export interface ApiError extends Error {
  status?: number;
  data?: unknown;
  requestName?: string;
  path?: string;
}

interface CreateApiErrorOptions {
  message: string;
  status?: number;
  data?: unknown;
  requestName?: string;
  path?: string;
}

interface ApiErrorEventDetail {
  error: unknown;
  requestName?: string;
  path: string;
}

export const createApiError = ({
  message,
  status,
  data,
  requestName,
  path
}: CreateApiErrorOptions): ApiError => {
  const error = new Error(message) as ApiError;
  error.status = status;
  error.data = data;
  error.requestName = requestName;
  error.path = path;
  return error;
};

export const dispatchApiErrorEvent = ({ error, requestName, path }: ApiErrorEventDetail): void => {
  if (typeof window === 'undefined') {
    return;
  }

  window.dispatchEvent(new CustomEvent('api-error', {
    detail: {
      error,
      requestName,
      path
    }
  }));
};
